import React from 'react';
import Title from './Title';
import './Header.css';

function Header(props) {
    return (
        <div className="header">             
            {
                props.img &&
                <img src={props.img}/>
            }
            <Title value={props.title}/>
            <div className='description'>{props.description}</div>        
            <div className='description'>{props.additional}</div>         
            <div className='long-divider'></div>
        </div>
    )
}

export default Header;